/* eslint-disable */

import React from 'react'
// import classNames from 'classnames'
import { Form, FormSpy } from 'react-final-form'
import { useSelector } from 'react-redux'

import WizardSlider from '@piconetworks/wizard-slider'
// import LandingWizardArrow from '@piconetworks/landing-wizard-arrow'
import Boutton from '@piconetworks/boutton'
import { colors } from '@piconetworks/functions'
import ConditionAggregator from '@piconetworks/condition-aggregator'
import WizardRedux from 'common/pkgs/WizardRedux'
import Loading from '@piconetworks/loading'

import getFields from 'apps/lib/getFields'

import Loader from 'common/modules/loader'
import styles from './GiftForm.module.scss'

const GiftForm = ({ onBackButtonClick, productOptionId }) => {
    const linkColor = useSelector(Loader.selectors.linkColor)
    const contrastColor = colors.getContrastColor(linkColor)
    const product = useSelector((state) => Loader.selectors.popupGetProductByProductOptionId(state, productOptionId))

    const productFields = useSelector((state) => Loader.selectors.popupGetProductFields(state, product?.id))
    const fields = getFields(productFields)

    const giftFields = getFields([{
        id: 'gift_form_1',
        title: 'Provide the following information to send your gift.',
        type: 'GiftForm',
        required: true,
        order: 0,
    }])

    const renderLoading = <Loading className={styles.btnLoading} />

    return (
        <WizardSlider
            title="Tell us about this gift."
            description="We will send this gift to the recipient on your behalf. The subscription will not begin until the recipient chooses to redeem the gift. The gift will not expire."
            linkColor={linkColor}
            onBackButtonClick={onBackButtonClick}
        >
            <WizardRedux.Step
                onSubmit={({ values }) => {
                    const wizardData = values?.wizardData

                    if (!wizardData) {
                        throw new Error('wizardData not provided')
                    }

                    return wizardData
                }}
                rffProps={{
                    mutators: {
                        setWizardData: (args, state, utils) => {
                            console.log('args', args)
                            utils.changeValue(state, 'wizardData', () => args[0])
                        },
                    },
                }}
                render={({
                    form,
                }) => (
                    <ConditionAggregator
                        Submit={({ submitConditionAggregator, isSubmitting }) => (
                            <Boutton
                                block
                                type="submit"
                                onClick={() => {
                                    submitConditionAggregator()
                                }}
                                style={{
                                    backgroundColor: linkColor,
                                    color: contrastColor
                                }}
                            >
                                {isSubmitting ? renderLoading : 'Go to checkout'}
                            </Boutton>
                        )}
                        onSubmit={async (e, data) => {
                            console.log('onSubmit', data?.preSubmitHookResults?.giftField)
                            // if (!data?.state?.customFields?.isComplete) {
                            //     throw new Error('finish custom fields')
                            // }

                            if (!data?.state?.giftField?.isComplete || !data?.preSubmitHookResults?.giftField) {
                                throw new Error('finish gift form')
                            }

                            return data?.preSubmitHookResults?.giftField
                        }}
                        postSubmit={(data) => {
                            console.log('postSubmit', data)

                            // advance to the next wizard step
                            form.mutators.setWizardData(data.submitResults)

                            form.submit()
                        }}
                        conditions={{
                            giftField: {
                                required: true,
                                isComplete: false,
                                preSubmit: async (data) => {
                                    const values = data?.payloads?.giftField?.gift_form_1 || {}

                                    if (
                                        !values.sender_name
                                        || !values.recipient_first_name
                                        || !values.recipient_email
                                    ) {
                                        throw Error(
                                            'You need to finish filling out the form',
                                        )
                                    }

                                    return {
                                        note: values.note || '',
                                        recipient: {
                                            first_name: values.recipient_first_name,
                                            email: values.recipient_email,
                                        },
                                        sender: {
                                            name: values.sender_name,
                                        },
                                    }
                                },
                                Component: ({ changeCompletionStatus }) => (
                                    <Form
                                        className={styles.formArea}
                                        style={{'--data-color': linkColor}}
                                        onSubmit={() => { }}
                                        render={() => (
                                            <form>
                                                <FormSpy
                                                    onChange={(props) => {
                                                        const hasSubmitValues = Object.keys(props?.values).length
                                                        const formIsValid = props.valid

                                                        if (!hasSubmitValues || !formIsValid) {
                                                            return
                                                        }

                                                        changeCompletionStatus({
                                                            isComplete: true,
                                                            ...props?.values,
                                                        })
                                                    }}
                                                />
                                                {giftFields.map((Field, idx) => (
                                                    <Field
                                                        key={idx}
                                                    />
                                                ))}
                                            </form>
                                        )}
                                    />
                                ),
                            },
                            // customFields: {
                            //     required: true,
                            //     isComplete: false,
                            //     preSubmit: async (data) => {
                            //         console.log('preSubmit customFields', data.payloads)
                            //     },
                            //     Component: ({ changeCompletionStatus }) => (
                            //         <Form
                            //             onSubmit={() => { }}
                            //             render={() => (
                            //                 <form>
                            //                     <FormSpy
                            //                         onChange={(props) => {
                            //                             const hasSubmitValues = Object.keys(props?.values).length
                            //                             const formIsValid = props.valid

                            //                             if (!hasSubmitValues || !formIsValid) {
                            //                                 return
                            //                             }

                            //                             changeCompletionStatus({
                            //                                 isComplete: true,
                            //                                 ...props?.values,
                            //                             })
                            //                         }}
                            //                     />
                            //                     {fields.map((Field, idx) => (
                            //                         <Field
                            //                             key={idx}
                            //                         />
                            //                     ))}
                            //                 </form>
                            //             )}
                            //         />
                            //     ),
                            // },
                        }}
                    />
                )}
            />
        </WizardSlider>
    )
}

export default GiftForm

// import React from 'react'
// import PropTypes from 'prop-types'
// import { Field } from 'react-final-form'
// import classNames from 'classnames'

// import WizardSlider from '@piconetworks/wizard-slider'
// import LandingWizardArrow from '@piconetworks/landing-wizard-arrow'
// import Form from '@piconetworks/form'
// import styles from './GiftForm.module.scss'

// class GiftForm extends React.Component {
//     render() {
//         const {
//             loader,
//             getScopedLoader,
//             thisWizard,
//             WizardRedux,
//             onBackButtonClick,
//         } = this.props

//         const scope = loader.user ? 'user' : 'guest'
//         const scopedLoader = getScopedLoader(scope) || {}
//         const { publisher: loaderPublisher = {} } = scopedLoader
//         const { styling = {} } = loaderPublisher
//         const { linkColor = '' } = styling
//         const {
//             submit: {
//                 payload: {
//                     sender: { name: sender_name } = {},
//                     recipient: {
//                         first_name: recipient_first_name,
//                         email: recipient_email
//                     } = {},
//                     note
//                 } = {}
//             } = {}
//         } = thisWizard || {}

//         const initialValues = {
//             ...(sender_name && { sender_name }),
//             ...(recipient_first_name && { recipient_first_name }),
//             ...(recipient_email && { recipient_email }),
//             ...(note && { note })
//         }

//         return (
//             <>
//                 <WizardSlider
//                     title="Tell us about this gift."
//                     description="We will send this gift to the recipient on your behalf. The subscription will not begin until the recipient chooses to redeem the gift. The gift will not expire."
//                     backButton={false}
//                     
//                 >
//                     <WizardRedux.Step
//                         {...(Object.keys(initialValues).length > 0 && {
//                             initialValues
//                         })}
//                         validate={() => {
//                             const errors = {}

//                             return errors
//                         }}
//                         onSubmit={({ values }) => {
//                             if (
//                                 !values.sender_name ||
//                                 !values.recipient_first_name ||
//                                 !values.recipient_email
//                             ) {
//                                 throw Error(
//                                     'You need to finish filling out the form'
//                                 )
//                             }

//                             return {
//                                 note: values.note || '',
//                                 recipient: {
//                                     first_name: values.recipient_first_name,
//                                     email: values.recipient_email
//                                 },
//                                 sender: {
//                                     name: values.sender_name
//                                 }
//                             }
//                         }}
//                         render={({ handleSubmit, submitError }) => (
//                             <div className={styles.formArea}>
//                                 <form onSubmit={handleSubmit}>
//                                     <Field
//                                         className={styles.formInput}
//                                         label="Your Name"
//                                         name="sender_name"
//                                         component={Form.Input}
//                                         type="text"
//                                     />
//                                     <Field
//                                         label="Recipient's Name"
//                                         name="recipient_first_name"
//                                         component={Form.Input}
//                                         type="text"
//                                     />
//                                     <Field
//                                         label="Recipient's Email"
//                                         name="recipient_email"
//                                         component={Form.Input}
//                                         type="text"
//                                     />
//                                     <Field
//                                         label="Gift Note"
//                                         name="note"
//                                         component={Form.TextArea}
//                                         type="text"
//                                     />
//                                     <LandingWizardArrow
//                                         buttonType="submit"
//                                         iconClass="icon-right"
//                                         className={classNames(
//                                             styles.iconContainer,
//                                             styles.right
//                                         )}
//                                         style={{ color: linkColor }}
//                                     />
//                                     <LandingWizardArrow
//                                         buttonType="button"
//                                         iconClass="icon-left"
//                                         onClick={() => {
//                                             onBackButtonClick()
//                                         }}
//                                         className={classNames(
//                                             styles.iconContainer,
//                                             styles.left
//                                         )}
//                                         style={{ color: linkColor }}
//                                     />
//                                     {submitError && (
//                                         <div className={styles.error}>
//                                             {submitError}
//                                         </div>
//                                     )}
//                                 </form>
//                             </div>
//                         )}
//                     />
//                 </WizardSlider>
//             </>
//         )
//     }
// }

// GiftForm.propTypes = {
//     loader: PropTypes.shape({
//         user: PropTypes.any
//     }).isRequired,
//     getScopedLoader: PropTypes.func.isRequired,
//     thisWizard: PropTypes.object.isRequired,
//     history: PropTypes.shape({
//         goBack: PropTypes.func.isRequired
//     }).isRequired,
//     WizardRedux: PropTypes.shape({
//         Step: PropTypes.element
//     }),
//     onBackButtonClick: PropTypes.func,
// }

// export default GiftForm
